import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Calendar, Users, ArrowRight, CreditCard } from 'lucide-react';
import MediaCarousel from '../components/MediaCarousel';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Packages = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await axios.get(`${API}/packages`);
        setPackages(response.data);
      } catch (error) {
        console.error('Error fetching packages:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchPackages();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="packages-loading">
        <p className="text-maroon text-xl">Loading packages...</p>
      </div>
    );
  }

  return (
    <div className="py-16" data-testid="packages-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-5xl sm:text-6xl font-heading font-bold text-maroon mb-6">
            Travel Packages
          </h1>
          <p className="text-xl text-maroon/70 max-w-3xl mx-auto">
            Discover our curated collection of group adventures to amazing destinations around the world.
          </p>
        </div>

        {packages.length === 0 ? (
          <div className="text-center py-12" data-testid="no-packages">
            <p className="text-xl text-maroon/70 mb-8">No packages available yet. Check back soon!</p>
            <Link to="/consultation" className="btn-primary">
              Book Custom Trip Instead
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {packages.map((pkg, idx) => (
              <div 
                key={pkg.id} 
                className="card group"
                data-testid={`package-${idx}`}
              >
                <Link to={`/packages/${pkg.id}`}>
                  <MediaCarousel 
                    media={pkg.media && pkg.media.length > 0 ? pkg.media : [pkg.image_url]}
                    alt={pkg.title}
                  />
                  <h3 className="font-heading font-bold text-2xl text-maroon mb-2 mt-4">{pkg.title}</h3>
                  <p className="text-maroon/70 mb-4 line-clamp-2">{pkg.description}</p>
                </Link>
                <div className="flex items-center justify-between text-sm text-maroon/60 mb-4">
                  <span className="flex items-center space-x-1">
                    <Calendar size={16} />
                    <span>{pkg.duration}</span>
                  </span>
                  <span className="flex items-center space-x-1">
                    <Users size={16} />
                    <span>{pkg.available_spots} spots left</span>
                  </span>
                </div>
                <div className="flex items-center justify-between mb-4">
                  <span className="text-2xl font-heading font-bold text-maroon">${pkg.price}</span>
                  <Link 
                    to={`/packages/${pkg.id}`}
                    className="text-terracotta font-semibold flex items-center space-x-1 hover:underline"
                  >
                    <span>View Details</span>
                    <ArrowRight size={16} />
                  </Link>
                </div>
                <Link 
                  to={`/book/${pkg.id}`}
                  className="btn-primary w-full flex items-center justify-center gap-2"
                  data-testid={`reserve-now-btn-${idx}`}
                >
                  <CreditCard size={18} />
                  Reserve Now
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Packages;